import { IEmeraldTabData } from '@emerald/nxcore';

export interface Vendors {
  vendorName: string;
  totalHeadCount: number;
  hyd: number;
  ncr: number;
  remote: number;
  regular: number;
  hybrid: number;
  partialHybrid: number;
  vendorId: number;
}

export interface OpsVendors {
  vendorName: string;
  totalEmployeesHeadCount: number;
  regularPercentage: number;
  hybridPercentage: number;
  partialHybridPercentage: number;
  pocName: string;
  pocEmail: string;
  pocPhoneNo: string;
  vendorContractExpiryDate: string;
  vendorOnboardingDate: string;
  actions: string;
  vendorId: number;
  remotePercentage: number;
}

export interface Contractors {
  contractorName: string;
  contractorId: string;
  designation: string;
  reportingManager: string;
  status: string;
  contractEndDate: string;
  primarySkill: string;
  dateOfJoining: string;
  vendorName: string;
  location: string;
  totalExperience: string;
  rto: string;
}

export interface ContractorsCountByMgr {
  managerName: string;
  designation: string;
  totalContractors: number;
  Hyderabad: number;
  NCR: number;
  Remote: number;
}

export interface ContractorsBySkills {
  contractorName: string;
  contractorId: number;
  vendorName: string;
  projectName: string;
  relevantExperience: string;
  cbreExperience: string;
  totalExperience: string;
  primarySkill: string;
  secondarySkill: string;
}

export interface TabState extends IEmeraldTabData {
  label: string;
  isTabActive: boolean;
  activeTab: boolean;
  value?: string;
}

export enum TabLabels {
  orgView = 'Org View',
  managerView = 'Manager View',
}

export interface TimesheetResponse {
  status: string;
  reason: string;
  data: TimeSheetData[];
}

export interface TimeSheetData {
  employeeId: string;
  employeeName: string;
  contractorName: string;
  jobTitle: string;
  vendorName: string;
  vendorId: number;
  location: string;
  l3ManagerName?: string;
  employeeStatus?: string;
  workingHrs: number;
  billableHrs: number;
  leavesAvailed: number;
  status: string | null;
  selected?: boolean;
  selectable?: boolean;
  pendingSubmission?: boolean;
  reportingManager: string;
  projectName: string;
  lastHireDate?: string;
  lastWorkingDay?: string;
  showBillingLink?: boolean;
}

export interface VendorEmployeeCount {
  ncremployeesHeadCount: number;
  partialHybridPercentage: number;
  totalEmployeesHeadCount: number;
  hyderabadEmployeesHeadCount: number;
  remoteEmployeesHeadCount: number;
  belowPartialHybridPercentage: number;
  regularPercentage: number;
  hybridPercentage: number;
  vendorId: number;
  vendorName: string;
  remotePercentage: number;
}
export interface Contractor {
  reportingManager: string;
  city: string;
  jobTitle: string;
}

export interface ManagerData {
  managerName: string;
  designation: string;
  totalContractors: number;
  Hyderabad: number;
  NCR: number;
  Remote: number;
}

export interface ContractorsCount {
  totalContractors: number;
  onBoardedContractors: number;
  offBoardedContractors: number;
}

export interface LeaveCommentsResponse {
  status: string;
  reason: string;
  data: LeaveComment[];
}

export interface LeaveComment {
  employeeId: string;
  managerComments: string;
  commentedManagerName: string;
  managerCommentsDate: string;
  vendorComments: string;
  vendorCommentsDate: string;
  commentedVendorName: string;
}

export interface TimesheetUpdateResponse {
  status: string;
  reason: string;
  data: TimesheetReview;
}

export interface TimesheetReview {
  employeeId: string[];
  reviewedBy: string;
  status: string;
  month: number;
  year: number;
}

export interface ContractorApiResponse {
  fullName: string;
  employeeId: string;
  jobTitle: string;
  reportingManager: string;
  status: string;
  contractEndDate: string;
  primarySkills: string;
  lastHireDate: string;
  employer: string;
  city: string;
  totalExperience: string;
  currentMonthAttendanceDays: number | null | undefined;
}

export interface TimesheetColumnDef {
  field: string;
  headerName: string;
  dataType?: string;
  cellRenderer?: any;
  checkboxSelection?: boolean;
  customCellTemplate?: string;
  hide?: boolean;
  minWidth?: string;
  filterParams?: {
    hideMenu?: boolean;
  };
  sortParams?: {
    enabled?: boolean;
  };
  sortComparator?: (a: any, b: any) => number;
  headerTemplate?: any;
}

export interface performanceEvaluationData {
  employeeId: string;
  employeeName: string;
  vendorName: string;
  vendorId: number;
  techincalRating: number;
  year: number;
  behaviouralRating: number;
  /** Bucketed Performance Rating for new-form submissions; null on legacy rows. */
  performanceRating?: string | null;
  comments: string | null;
  quarter: string;
  selected?: boolean;
}